export enum ParticipantTypeEnum {
  Signatory = 1,
  Authorizer = 2,
  Observer = 3,
  Responsible = 4,
}
